<template>  
    <div>    
        <v-divider />                  
        <!-- <v-subheader>
          <span class="format-coord">{{$t('CoordSelector.Tooltip')}} ({{formatName}})</span>
        </v-subheader > -->
        <v-list-tile v-for="item in coordFilters" :key="item.label" @click="$store.myActions.UI_SET_COORDFORMATER(item.value)">
          <v-list-tile-title v-text="item.label"></v-list-tile-title>
          <v-list-tile-action>
            <v-spacer />                        
            <v-icon v-text="formatValue == item.value?'mdi-radiobox-marked':'mdi-radiobox-blank'" />
          </v-list-tile-action>
        </v-list-tile>        
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CoordSelector',
    data() {
      return {        
        coordFilters: [
          {label : 'DD°MM′SS″', value: 'formatEPSG4326ToHDMS'},
          {label : 'DD°MM.mm′', value: 'formatEPSG4326ToGlider'},
          {label : 'DD.dd°', value: 'formatEPSG4326'}
        ]
      }
    },
   computed: {
       ...mapGetters([
        'coordFormatFilter']),
      formatName(){
        return this.coordFilters.find(f => f.value == this.coordFormatFilter).label
      },
      formatValue(){
        return this.coordFilters.find(f => f.value == this.coordFormatFilter).value
      }

    },
    methods: {
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.format-coord{
  font-size: 12px;
}
  .back{
    flex-grow: 1;
  }
  h2 {
    flex: 0 0 auto;
    margin-left: 12px;
  }
   h3 {
    flex: 0 0 auto;
    margin-left: 12px;
  }
</style>
